export function createURLSearchParams(params: Record<string, unknown>): string {
  const urlSearchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      urlSearchParams.append(key, value.toString());
    }
  });
  return urlSearchParams.toString();
}

export function removeWindowURLSearchParams() {
  let windowURL = window.location.href;
  const queryParamStart = windowURL.indexOf("?");
  if (queryParamStart !== -1) {
    windowURL = windowURL.slice(0, queryParamStart);
  }
  window.history.replaceState(null, "", windowURL);
}

export function removeWindowURLSearchParam(key: string) {
  const searchParams = new URLSearchParams(window.location.search);
  searchParams.delete(key);

  const newSearchParams = searchParams.toString();
  const newUrl = `${window.location.pathname}${newSearchParams ? `?${newSearchParams}` : ""}`;

  window.history.replaceState(null, "", newUrl);
}
